import { Icon } from "@iconify/react";
import { Collapse, Typography } from "antd";
import React from "react";

const { Panel } = Collapse;
const { Text } = Typography;

interface FilterCollapseSectionProps {
  title: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
}

const FilterCollapseSection: React.FC<FilterCollapseSectionProps> = ({
  title,
  children,
  defaultOpen = true,
}) => {
  return (
    <Collapse
      defaultActiveKey={defaultOpen ? ["1"] : []}
      bordered={false}
      expandIconPlacement="end"
      expandIcon={({ isActive }) => (
        <Icon
          icon="solar:alt-arrow-down-outline"
          style={{ transform: isActive ? "rotate(180deg)" : undefined }}
        />
      )}
      style={{ background: "transparent" }}
    >
      <Panel header={<Text strong>{title}</Text>} key="1">
        {children}
      </Panel>
    </Collapse>
  );
};

export default FilterCollapseSection;
